<template>
  <sf-color-text :color="getStockStatusColor(stock.status)">
    {{ stock.count > 0 ? stock.count : '' }}
    {{ $t('stockStatus.' + stock.status) }}
  </sf-color-text>
</template>

<script setup lang="ts">
import SfColorText from '@/components/text/SfColorText.vue'
import { getStockStatusColor } from '@/modules/product/helpers'
import { SimpleStock } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  stock: {
    type: Object as PropType<SimpleStock>,
    required: true
  }
})
</script>
